export enum AlgoregSessionType {
  Info = "INFO",
  Question = "QUESTION",
  Fusion = "olkypass_3in1"
}

export enum AlgoregSessionStatusType {
  UNFINISHED = "UNFINISHED",
  NEGATIVE = "NEGATIVE",
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE"
}

export type InitAlgoregSessionRequestDto = {
  language: string;
  documentTypeCode: number;
};

export type AlgoregSessionState = {
  sessionId: string;
  statusType: AlgoregSessionStatusType;
};

export type AlgoregSessionIdContainer = {
  sessionId: string;
};
